<section *ngIf="(errorsService.errorState$ | async) as state">
  <img [src]="state.imageUrl" alt="error image" loading="lazy">
  <h1>{{state.title}}</h1>
  <p [innerHTML]="state.message"></p>
  <button *ngFor="let button of state.buttons" (click)="onButtonClick(button.routerLink, button.routerParams, button.callback)" class="btn btn-light">{{button.text}}</button>
</section>
